import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ListGroup, Overlay, Popover } from 'react-bootstrap';
import styled from 'styled-components';

import Icon from '../../../Icon/Icon';
import Text from '../../../Text/Text';

const Item = styled(ListGroup.Item)`
  background-color: var(--dropdown);
  color: var(--dark);
  display: flex;
  gap: 6px;
  align-items: center;
`;

export default function AppPill({
  app,
  currentApp,
  currentDefaultApp,
  toggleApp,
  closeDropdown,
  onScrollClose,
  pinApp,
  unpinApp,
  setDefaultApp,
  disablePin,
  pinText,
  openMenuId,
  setOpenMenuId,
  section,
}) {
  const dotsRef = useRef(null);
  const showMenu = openMenuId === app.id;

  // If scrolling inside the switcher → close any open menus
  useEffect(() => {
    if (onScrollClose) setOpenMenuId(null);
  }, [onScrollClose]);

  // MAIN RENDER
  return (
    <Link to="/">
      <div
        className="app-pill d-flex"
        onClick={() => {
          toggleApp(app);
          closeDropdown?.();
        }}
      >
        {/* LEFT: Icon + Name */}
        <div className="right-side">
          <Icon
            containerClassName="app-pill-button"
            name="url"
            variant="light"
            disabled={true}
            size="sm"
          />

          <Text className={`app-text ${app.id === currentApp?.id ? 'selected' : ''}`}>
            {app.name}
          </Text>
        </div>

        {/* RIGHT: Default label + Pin / Menu */}
        <div className="left-side d-flex gap-2">
          {/* Show DEFAULT tag */}
          {app.id === currentDefaultApp && <Text className="default fs-sm">Default</Text>}

          {/* Unpin button (only in pinned section) */}
          {section === 'pinned' && (
            <div className="wrap-apps-icon">
              <Icon
                containerClassName="app-pill-button"
                name="push_pin"
                variant="light"
                disabled={false}
                size="sm"
                title="Unpin"
                showPointer
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  unpinApp(app.id);
                }}
              />
            </div>
          )}

          {/* Dots menu (only in the list section) */}
          {section === 'list' && (
            <div
              className="wrap-apps-icon"
              ref={dotsRef}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpenMenuId(showMenu ? null : app.id);
              }}
            >
              <Icon
                containerClassName="app-pill-button"
                name="h-dots"
                variant="light"
                size="sm"
                showPointer
              />
            </div>
          )}

          {/* POPOVER MENU */}
          <Overlay
            target={dotsRef.current}
            show={showMenu}
            placement="left"
            rootClose
            onHide={() => setOpenMenuId(null)}
          >
            <Popover className="small-app-action">
              <Popover.Body>
                <ListGroup variant="flush">
                  {/* Pin App */}
                  <Item
                    action
                    disabled={disablePin}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (!disablePin) pinApp(app);
                      setOpenMenuId(null);
                    }}
                  >
                    <i className="sonarIcon sonarIcon-push_pin fs-sm" />
                    <Text>{pinText}</Text>
                  </Item>

                  {/* Set Default */}
                  <Item
                    action
                    disabled={app.id === currentDefaultApp}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setDefaultApp(app);
                      setOpenMenuId(null);
                    }}
                  >
                    <i className="sonarIcon sonarIcon-star fs-sm" />
                    <Text>Set as Default</Text>
                  </Item>
                </ListGroup>
              </Popover.Body>
            </Popover>
          </Overlay>
        </div>
      </div>
    </Link>
  );
}
